/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '../../services/toast';
export default {
  name: 'noraml-user-org-list',
  components: {},
  props: [],
  data () {
    return {
      orgList:{},
      nextStep:'',
      orgListResults:[],
      loadmoreData: {},
      userLoading: false,
      submitted:false,
      chatRequestId:'',
      checkDataTaskModal:false,
      userId:'',
      message:'',
    }
  },
  computed: {
  ...mapGetters([
    'normalUserOrgListGetter',
    'acUserDetailsStateGetters'
  ]),
  getOrgListDetailsFun(){
    return this.orgList = this.$store.getters.normalUserOrgListGetter.data
  },
  SetIntialStatus() {
    if (this.orgList != undefined) {
      this.nextStep = this.orgList.next
      this.orgListResults = this.orgList.results
    }
  },
  getUserDetailsAgainFun(){
    this.userId = this.$store.getters.acUserDetailsStateGetters.data
    return
  }
  },
  mounted () {
    this.getUserDetailsAgainFun
    this.getOrgListDetailsFun
    this.SetIntialStatus
  },
  methods: {
    chatRequestSend(id){
      this.checkDataTaskModal = true
      this.chatRequestId = id
    },
    closeChatRequestConfirm(){
      this.checkDataTaskModal = false,
      this.chatRequestId = '',
      this.message = ''
    },
    sendChatRequestConfirm(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              from_user:this.userId.id,
              organization:this.chatRequestId,
              message:this.message,
            }
            this.$store.dispatch('SendChatConnectionRequestFun', data)
              .then((res) => {  
                  toast.success(res.data.msg);   
                  this.checkDataTaskModal = false
                  this.chatRequestId = ''  
                  this.message = ''       
              }).catch((err) => {
                toast.error(eerr.data.user_msg || err.data.msg);
              })
            return;
        }
      });
    }
  },
  watch:{
    getOrgListDetailsFun(){
      return this.orgList = this.$store.getters.normalUserOrgListGetter.data
    },
    SetIntialStatus() {
      if (this.orgList != undefined) {
        this.nextStep = this.orgList.next
        this.orgListResults = this.orgList.results
      }
    },
    getUserDetailsAgainFun(){
      return this.$store.getters.acUserDetailsStateGetters.data
    },
  }
}


